import { IoMdCloseCircle } from '@react-icons/all-files/io/IoMdCloseCircle';
import clsx from 'clsx';
import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Col, Row } from 'components/GridV2';

import { IQueryParams } from 'typescriptDefs';

import { trackEventUniversal, useIsMobile } from 'helpers';
import { generalAppsFlyerIds } from 'helpers/getAfTracking';

import { GetKOHOBtn } from './GetKOHOBtn';
import { LocaleContext } from './Layout';

export const SmartBanner = ({ queryParams, newHomepage }: { queryParams: IQueryParams; newHomepage?: boolean }) => {
  const isMobile = useIsMobile();
  const locale = useContext(LocaleContext);
  const [wasBannerClosed, setWasBannerClosed] = useState<boolean>(false);

  const keySession = 'viewedSmartBannerBasic?';
  const [isKeySessionPresent, setIsKeySessionPresent] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    // Make sure smartbanner only appears on first page user arrives at
    if (isMobile) {
      const keySessionPresent = sessionStorage.getItem(keySession);
      if (!keySessionPresent) {
        setIsKeySessionPresent(false);
        sessionStorage.setItem(keySession, 'true');
      } else setIsKeySessionPresent(true);
    }
  }, [isMobile]);

  // Event tracking for banner views
  useEffect(() => {
    if (isKeySessionPresent === false) {
      trackEventUniversal('Smart banner viewed', {
        event_category: 'Smart banners',
        event_label: 'Smart Banner basic',
      });
    }
  }, [isKeySessionPresent]);

  if (isKeySessionPresent || wasBannerClosed) return null;

  return (
    <div className="fixed bottom-32 left-1/2 z-[900] block w-full -translate-x-1/2 animate-fadeIn5 px-96 transition-opacity duration-[0.3s] xs:bottom-16 md:hidden">
      <Row className="relative -mx-16 rounded-128 shadow-[0_12px_24px_rgba(21,45,64,0.5)]">
        <BtnClose setWasBannerClosed={setWasBannerClosed} />
        <Col className="w-full px-0">
          <GetKOHOBtn
            buttonClassName={twMerge(clsx('py-16 px-32 xs:px-16 w-full block font-medium text-lg sm:text-2xl'))}
            buttonLocation="Smart banner basic"
            queryParams={{
              hash: queryParams.hash,
              search: {
                ...queryParams.search,
                af_adset_id: generalAppsFlyerIds.SMART_BANNER,
              },
            }}
            trackEventProps={{
              category: 'Smart Banner',
              label: 'Banner Basic',
              locale,
            }}
          >
            {{ en: 'Open Account', fr: 'Ouvrir un compte' }[locale]}
          </GetKOHOBtn>
        </Col>
      </Row>
    </div>
  );
};

const BtnClose = ({ setWasBannerClosed, ...props }: { setWasBannerClosed: Dispatch<SetStateAction<boolean>> }) => (
  <button
    className="absolute left-0 top-0 z-[20] animate-fadeIn75 rounded-[50%]"
    onClick={() => {
      setWasBannerClosed(true);
      trackEventUniversal('Smart banner closed', {
        event_category: 'Smart banners',
        event_label: 'Smart banner basic',
      });
    }}
    {...props}
  >
    <div className="relative">
      <div className="absolute left-1/2 top-1/2 h-[1.6em] w-[1.6em] -translate-x-1/2 -translate-y-1/2 rounded-[50%] bg-primary-500 sm:h-[2em] sm:w-[2em]" />
      <IoMdCloseCircle className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-[1.6em] text-white sm:text-[2em]" />
    </div>
  </button>
);
